export default "__VITE_ASSET__CXqNgORO__"